module.exports = __webpack_public_path__ + "static/media/0175_Medium.6a9a2fbd.jpg";